import { z } from 'zod';
/**
 * REST bodies. M0 ships only the unauthenticated operational endpoints; join,
 * seat claim, and orders arrive with M2 (§3.2, §8.4).
 */
export const zDbHealth = z.object({
    status: z.enum(['up', 'down']),
    latencyMs: z.number().nonnegative().optional(),
    error: z.string().optional(),
});
/**
 * `GET /healthz` — process + DB ping (§16.3).
 *
 * Returns 200 when `status === 'ok'` and 503 when `status === 'degraded'`, so a
 * load balancer or uptime check needs no body parsing, while a human gets the
 * detail.
 */
export const zHealthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    /** Absolute epoch ms on the *server* clock — clients correct against this (§8.2). */
    serverTimeMs: z.number().int(),
    uptimeMs: z.number().int().nonnegative(),
    version: z.string(),
    db: zDbHealth,
});
/**
 * `GET /api/version` — build and rule-content identity.
 *
 * `contentHash` is the §10.1 hash of the rule tables this process is running. A
 * game records the hash it started with and refuses to resolve against a
 * different one without GM acknowledgement, so this endpoint is how the GM
 * console detects that a deploy has moved the rules underneath a live exercise.
 */
export const zVersionResponse = z.object({
    service: z.literal('badger-sentinel'),
    version: z.string(),
    gitSha: z.string().nullable(),
    contentVersion: z.string(),
    contentHash: z.string(),
    protocolVersion: z.number().int(),
    serverTimeMs: z.number().int(),
});
//# sourceMappingURL=http.js.map